import React, { useState, useEffect } from 'react'
import axios from "axios";
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import Loader from './Loader'


function Allmarket() {
  // const [user, setUsers] = useState(null);
  const [userr, setUserss] = useState(null);
  const [useadvertisement, setadvertisement] = useState(null);
  const [useadvertisement1, setadvertisement1] = useState(null);
  const [usefetchAdvertisements2, setfetchAdvertisements2] = useState(null);
  const [useallMarketData, setuseallMarketData] = useState(null);
  const [usefetchAdvertisements3, setfetchAdvertisements3] = useState(null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // Track loading state


  const [time, setTime] = useState(null);
  console.warn(time)
 


  

  const formatTime12Hour = (time24Hour) => {
    const [hour, minute] = time24Hour.split(':');
    const hour12 = (hour % 12) || 12;




    const period = hour < 12 ? 'AM' : 'PM';
    return `${hour12}:${minute} ${period}`;
  };
 
  useEffect(() => {
    loaduser();
    results();
    loaduser1();

  }, []);
  const handleYearChange = (event) => {
    setYear(event.target.value);
  };
  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };
  const handleSubmit = () => {
    results(year, month);
  };
  const [year, setYear] = useState("2020");
  const [month, setMonth] = useState("01");
  const [useresults, setresults] = useState(null);
  const [uniqueDates, setUniqueDates] = useState([]);
  const [uniquemarketname, setUniquemarketname] = useState([]);
  const monthAbbreviations = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec"
  };

  const results = async (year, month) => {
    setLoading(true);

    console.warn(year,month)
    try {
      // Get the current date, year, and month
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonthIndex = currentDate.getMonth(); // 0-based index (0 = Jan, 11 = Dec)
      const monthAbbreviations = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const currentMonthAbbr = monthAbbreviations[currentMonthIndex];
// alert(monthAbbreviations)
      // Use passed values or default to current year and month
      const formData = new FormData();
      formData.append('year', year || currentYear);
      formData.append('month', month || String(currentMonthIndex + 1).padStart(2, '0')); // Ensure "MM" format

      // const response = await fetch(`${process.env.REACT_APP_API_URL}public/api/satta-king-record-chart`, {
      const response = await fetch("https://a-71ajsatta.com/Admin/public/api/satta-king-record-chart", {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.warn(data); // Log the response data

      const selectedMonthAbbr = monthAbbreviations[parseInt(month, 10) - 1] || currentMonthAbbr;
      // alert(monthAbbreviations)

      if (data.data && data.data[selectedMonthAbbr] && data.data[selectedMonthAbbr].length > 0) {
        setresults(data.data[selectedMonthAbbr]);
        const dates = data.data[selectedMonthAbbr].map(entry => entry.date);
        const uniqueDates = [...new Set(dates)];
        setUniqueDates(uniqueDates);

        const marketNames = data.data[selectedMonthAbbr].map(entry => entry.market_name);
        const uniqueMarketNames = [...new Set(marketNames)];
        setUniquemarketname(uniqueMarketNames);
        console.warn("Unique Market Names:", uniqueMarketNames);
      } else {
        console.error(`No data available for the selected or default month (${currentMonthAbbr}) and year.`);
      }
    } catch (error) {

      console.error('Error:', error);
    }finally {
      setLoading(false); // Set loading to false after the data is fetched or error occurs
    }
  };




  const [usemarketname, setusemarketname] = useState("");

  const [useyearr, setyearr] = useState("");
  const [titlee, settitlee] = useState("");

  const loaduser = async () => {
    // const market_id = localStorage.getItem("market_id");
    // alert(market_id)
    // console.warn(market_id)

    // alert(user_id);
    let url = `https://a-71ajsatta.com/public/api/satta-chart-record2024`;
    // console.warn(url);
    // const formData = new FormData();
    // formData.append("market_id", market_id);
    // alert(dev_id)
    var config = {
      method: "POST",
      url: url,
    };
    axios
      .post(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        const objectRes = JSON.parse(res);
        setusemarketname(objectRes);
        console.warn(objectRes);

        const year = objectRes.data.year;
        const title = objectRes.data.title;
        // alert(livetime)
        setyearr(year);
        settitlee(title);
      })
      .finally(() => {
        // setTimeout(() => {
        // }, 1000);
      });
  };

  const handleClick1 = async (market_id) => {
    navigate("/Result");
    localStorage.setItem("marketchart_id", market_id);
  };

  const [usemarketnamee, setusemarketnamee] = useState("");
  const [useyear, setyear] = useState("");
  const [title, settitle] = useState("");
  //  console.log(usetitleyear)

  const loaduser1 = async () => {
    // let url = `${process.env.REACT_APP_API_URL}public/api/satta-chart-record2023`;
    let url = `https://a-71ajsatta.com/public/api/satta-chart-record2023`;

    var config = {
      method: "POST",
      url: url,
    };
    axios
      .post(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        const objectRes = JSON.parse(res);
        setusemarketnamee(objectRes);

        const year = objectRes.data.year;
        const title = objectRes.data.title;
        // alert(livetime)
        setyear(year);
        settitle(title);
      })
      .finally(() => {
        // setTimeout(() => {
        // }, 1000);
      });
  };
  const handleClick2 = async (market_id) => {
    navigate('/Market');
    localStorage.setItem('marketchart_id', market_id,);

  };

  
  return (

    <>
    {loading ? (
      <Loader/>
    ) : (

      <>

      <section className="allmarket">
        <div className="octoberresultchart">
          {/* 
                          <div class="gcse-search"></div> */}


          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="chart_record">
                  <div className="d-flex justify-content-center">
                    <select value={year} onChange={handleYearChange}>

            
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>

                      <option value="2025">2025</option>
                      <option value="2026">2026</option>

                    </select>

                    <select value={month} onChange={handleMonthChange}>

                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>

                    <button className="btn btn-success" onClick={handleSubmit} style={{ padding: "1px", marginBottom: "5px" }}>GO</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='newtable'>
          <div className="nopadding">
            {uniquemarketname.length > 1 && (
              <div className="table-responsive">

                <table className="table table-bordered">
                  <tbody>

                    <tr>
                      <th className="forfirtcolor">Date</th>
                      {uniqueDates.slice(0, 1).map(date => (
                        <React.Fragment>
                          {useresults
                            .filter(entry => entry.date === date).slice(0, 15)
                            .map(entry => (
                              <th className="forfirtcolor">
                                {entry.market_name}
                              </th>
                            ))}
                        </React.Fragment>
                      ))}
                    </tr>


                    {uniqueDates.map(date => (
                      <tr>
                        <React.Fragment>
                          <td className='forfirtcolor'>
                            {new Date(date).getDate()}/{new Date(date).getMonth() + 1}/{new Date(date).getFullYear()}
                          </td>
                          {useresults
                            .filter(entry => entry.date === date).slice(0, 31)
                            .map(entry => (
                              <React.Fragment>



                                <td>
                                  {/* {entry.result} */}
                                  { entry.result}
                                  {/* {entry.result <= 9 || entry.result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  entry.result
                                )} */}
                                  {/* {(entry.result === "" || /^\d$/.test(entry.result)) ? (
                                    <div className="sattaresult">
                                      <font>
                                        <span>
                                          <strong>
                                            <h1 className="text-red blink-soft">Wait</h1>
                                          </strong>
                                        </span>
                                      </font>
                                    </div>
                                  ) : (
                                    entry.result)} */}




                                </td>
                              </React.Fragment>
                            ))}


                        </React.Fragment>
                      </tr>
                    ))}


                  </tbody>
                </table>
              </div>
            )}
          </div>

        </div>
      </section>


    </>
  )}
    </>
  

  )
}

export default Allmarket

